/**
 * Created by zhengyongbo on 2018/7/12.
 */
import module_system from './module_system'
import module_data_input from './module_data_input'
import module_data_analysis from './module_data_analysis'
import module_data_output from './module_data_output'
import module_epidemic from './module_epidemic'

const modules_routes = [
  ...module_system,
  ...module_data_input,
  ...module_data_analysis,
  ...module_data_output,
  ...module_epidemic,
];
export default modules_routes;
